// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eed67164","239":"06ac379b","453":"68693753","667":"b4c12287"}[chunkId] + ".chunk.js";
};